import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex h-dvh w-full items-center justify-center overflow-y-auto bg-[url('/img/login-bg.png')] bg-cover bg-right py-8 sm:px-8 lg:max-w-none" }
const _hoisted_2 = {
  key: 0,
  class: "w-full px-6 sm:px-0 lg:max-w-[500px]"
}
const _hoisted_3 = { class: "flex flex-col gap-12 text-white" }
const _hoisted_4 = { class: "text-2xl font-semibold sm:text-3xl" }
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "text-xl font-semibold sm:text-2xl" }
const _hoisted_7 = { class: "text-sm font-light sm:text-lg" }
const _hoisted_8 = { class: "grid auto-cols-fr grid-flow-col" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_10 = {
  key: 1,
  class: "flex justify-center gap-4"
}
const _hoisted_11 = {
  key: 1,
  class: "w-full px-2 sm:px-0 lg:max-w-[500px]"
}
const _hoisted_12 = { class: "flex flex-col gap-12 text-white" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_14 = { class: "text-center text-2xl font-semibold" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_16 = { class: "text-2xl font-semibold" }
const _hoisted_17 = { class: "text-lg font-light" }
const _hoisted_18 = {
  key: 2,
  class: "grid auto-cols-fr grid-flow-col"
}
const _hoisted_19 = {
  key: 3,
  class: "flex justify-center"
}
const _hoisted_20 = {
  key: 4,
  class: "flex justify-center gap-4"
}
const _hoisted_21 = {
  key: 2,
  class: "relative my-auto flex w-full max-w-[calc(100%-2rem)] flex-col rounded-lg bg-white p-5 shadow-lg duration-200 sm:min-h-[700px] sm:max-w-2xl"
}

import { computed, ref } from 'vue';
    import { Head } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import KeepersLogo from '@/components/icons/KeepersLogo.vue';
    import OnboardingGuideItem from '@/components/onboarding/OnboardingGuideItem.vue';
    import type { SharedData } from '@/types';
    import OnboardingAssistant from '@/components/onboarding/OnboardingAssistant.vue';
    import { router } from '@inertiajs/vue3';
    import { Button } from '@/components/ui/button';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerIndex',
  setup(__props) {

    const { t } = useI18n();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const open = ref(false);
    const completedSteps = ref(false);
    const completed = ref(false);

    const steps = computed(() => {
        const allSteps = page.props.auth.onboarding_steps;
        return [...allSteps].sort((a, b) => {
            if (a.is_completed && !b.is_completed) return 1;
            if (!a.is_completed && b.is_completed) return -1;
            return 0;
        });
    });

    const firstVisit = computed(() => {
        return steps.value.every((step) => step.status === 'pending');
    });

    const translationKey = computed(() => {
        return firstVisit.value ? 'steps_intro' : 'steps_intro_missing';
    });

    const handleCompleted = (incompleteSteps: number) => {
        completedSteps.value = true;
        if (incompleteSteps === 0) {
            completed.value = true;
        }
        open.value = false;
    };

    const goToDashboard = () => {
        router.visit(route('v2.index'));
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('onboarding.page_header')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(KeepersLogo, {
        type: "light",
        class: "absolute top-8 left-8 hidden max-w-24 sm:max-w-36 lg:block"
      }),
      (!open.value && !completedSteps.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(KeepersLogo, {
                type: "light",
                class: "block max-w-36 lg:hidden"
              }),
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)(`onboarding.${translationKey.value}.title`, { name: _unref(page).props.auth.user.name })), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(t)(`onboarding.${translationKey.value}.subtitle`)), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)(`onboarding.${translationKey.value}.content`)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
                  return (_openBlock(), _createBlock(OnboardingGuideItem, {
                    key: step.id,
                    "onboarding-step": step,
                    type: "light",
                    class: _normalizeClass({
                            'opacity-40': step.is_completed,
                        })
                  }, null, 8, ["onboarding-step", "class"]))
                }), 128))
              ]),
              (firstVisit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(Button), {
                      variant: "default",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_intro.button')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      onClick: goToDashboard,
                      class: "text-foreground bg-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_intro_missing.skip')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      variant: "default",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_intro_missing.button')), 1)
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ]))
        : (!open.value && completedSteps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(KeepersLogo, {
                  type: "light",
                  class: "block max-w-36 lg:hidden"
                }),
                _createElementVNode("h1", {
                  class: _normalizeClass(["text-3xl font-semibold", {
                        'text-center': completed.value,
                    }])
                }, _toDisplayString(_unref(t)('onboarding.steps_completed.title')), 3),
                (completed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(t)(`onboarding.steps_completed.subtitle`)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(t)(`onboarding.steps_completed_missing.subtitle`)), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)(`onboarding.steps_completed_missing.content`)), 1)
                    ])),
                (!completed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
                        return (_openBlock(), _createBlock(OnboardingGuideItem, {
                          key: step.id,
                          "onboarding-step": step,
                          type: "light",
                          class: _normalizeClass({
                            'opacity-40': step.is_completed,
                        })
                        }, null, 8, ["onboarding-step", "class"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (completed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_unref(Button), {
                        variant: "default",
                        onClick: goToDashboard
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_completed.button')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_unref(Button), {
                        variant: "outline",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (open.value = true)),
                        class: "text-foreground bg-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_completed_missing.back')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        variant: "default",
                        onClick: goToDashboard
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('onboarding.steps_completed_missing.button')), 1)
                        ]),
                        _: 1
                      })
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
      (open.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(OnboardingAssistant, {
              "onboarding-steps": steps.value,
              "company-id": selectedCompanyId.value,
              modelValue: open.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((open).value = $event)),
              onCompleted: handleCompleted,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (open.value = false))
            }, null, 8, ["onboarding-steps", "company-id", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})